import { useFormik } from 'formik';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import { signUpUserApi } from '../../api/auth.api';
import { toast } from 'react-hot-toast';
import { REGEX_EMAIL, REGEX_USERNAME, REGEX_PASSWORD } from '../../constant/Regex.js'
import SignUp from '../../components/auth/SignUp';

const SignUpContainer = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
    },
    validationSchema: yup.object().shape({
      username: yup.string().min(5, 'Too Short').required('Required').matches(REGEX_USERNAME, 'Username may include _ and – having a length of 5 to 30 characters'),
      email: yup.string().required('Required').matches(REGEX_EMAIL, 'Email invalid'),
      password: yup.string().required('Required').matches(REGEX_PASSWORD, 'Password must be 8 to 20 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character!'),
      confirmPassword: yup.string().required('Required').oneOf([yup.ref("password"), null], 'Confirmed password must match password'),
      firstName: yup.string().required('Required'),
      lastName: yup.string().required('Required')
    }),
    onSubmit: values => {
      const data = {
        firstName: values.firstName,
        lastName: values.lastName,
        username: values.username,
        email: values.email,
        password: values.password
      }
      signUpUserApi(data, dispatch, toast, setShowPopup);
    }
  })

  const togglePassword = () => {
    setShowPassword(!showPassword);
  }

  return (
    <SignUp
      formik={formik}
      setShowPopup={setShowPopup}
      showPassword={showPassword}
      showPopup={showPopup}
      togglePassword={togglePassword}
    />
  )
}

export default SignUpContainer